export default __webpack_public_path__ + "static/media/1-tablet.93310360.jpg";